import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconWorkExperienceSvg } from "./IconWorkExperienceSvg.mjs";
const IconWorkExperience = (props) => /* @__PURE__ */ jsx(
  IconContainer,
  {
    ...props,
    verticalCorrection: {
      uppercase: "up",
      lowercase: "up"
    },
    children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconWorkExperienceSvg, ...svgProps })
  }
);
export {
  IconWorkExperience
};
